import { z } from "zod";
export { start } from "./client.js";
/** URL for the embeddable meme maker. */
export const MEME_MAKER_URL = "https://maker.memefighter.app";
/** Message types which will be exchanged between iframe (server) and parent (client). */
export var MessageType;
(function (MessageType) {
    // Server -> Client
    MessageType["READY"] = "READY";
    // Client -> Server
    MessageType["INIT"] = "INIT";
    // Server -> Client
    MessageType["INIT_RESPONSE"] = "INIT_RESPONSE";
    // Server -> Client
    MessageType["MEME_CREATED"] = "MEME_CREATED";
})(MessageType || (MessageType = {}));
/** Configuration which allows third-party to customize appearance of the meme maker. */
export const styleVariables = z.object({
    "--background-color": z.string().optional(),
    "--foreground-color": z.string().optional(),
    "--button-color": z.string().optional(),
});
/** Message sent from iframe to parent once iframe is loaded and ready to receive messages. */
export const readyMessage = z.object({
    messageType: z.literal(MessageType.READY),
});
/** Message sent from parent to iframe to initialize meme making and provide customization parameters. */
export const initMessage = z.object({
    messageType: z.literal(MessageType.INIT),
    payload: styleVariables,
});
/** Message sent from iframe to parent indicating initialization success, or errors which were encountered. */
export const initResponseMessage = z.object({
    messageType: z.literal(MessageType.INIT_RESPONSE),
    payload: z.discriminatedUnion("status", [
        z.object({
            status: z.literal("ok"),
            ok: z.null(),
        }),
        z.object({
            status: z.literal("err"),
            err: z.array(z.string()),
        }),
    ]),
});
/** Message sent from iframe to parent when the user has finished creating a meme. */
export const memeCreatedMessage = z.object({
    messageType: z.literal(MessageType.MEME_CREATED),
    payload: z.string(),
});
//# sourceMappingURL=index.js.map